<template>
    <div class="d-flex">
        <div class="avatar-cont mr-2" style="margin-left: -32px">
            <PersonAvatar :size="24" :person="item.person"/>
        </div>
        <div class="fill-width">
            <div class="activity-row">
                <span
                    :class="['comment-name font-weight-medium', current_account.id === item.person.id ? 'me' : '']"
                >
                    {{ item.person | format_name }}
                </span>
                <span class="comment-type">
                    {{ taskLogType }}
                    <span class="n5--text subtitle-2 font-weight-bold cursor-pointer text-decoration-underline" @click="isActive = !isActive">”{{ subject }}”</span>
                </span>
            </div>

            <v-expand-transition>
                <div v-show="isActive" style="max-height: 500px" class="overflow-y-auto grey-content fill-width my-1">
                    <div v-html="content"/> <!-- INPUT CLEANED WHEN SAVING -->
                </div>
            </v-expand-transition>
            <Footer
                :created_at="item.created_at"
            />
        </div>
    </div>
</template>

<script>
import {$t} from "@/i18n";
import PersonAvatar from "../../../../components/PersonAvatar";
import AccountModule from "../../../../store/modules/account";
import TaskEditCommentControl from "../../TaskEditCommentControl";
import {ref, computed} from "@vue/composition-api";
import {TASK_LOG_TYPE} from "../../../../helpers/constants";
import Footer from "../Footer.vue"

export default {
    name: "EmailRow",
    components: {
        PersonAvatar,
        TaskEditCommentControl,
        Footer
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props, ctx) {
        const { current_account } = AccountModule();
        const isActive = ref(false)

        const subject = computed(() => {
            let match = props.item.message.match(/Subject: (?<subject>.+)/)

            return match ? match['groups']['subject'] : ''
        })

        const content = computed(() => {
            let split = props.item.message.split('\n')
            return split.length > 1 ? split[1] : ''
        })

        const taskLogType = computed(() => {
            let data = {};

            // notice :: TASK_LOG_TYPE
            data[TASK_LOG_TYPE.TASK_EMAIL_ADDED] = $t('added email')
            data[TASK_LOG_TYPE.TASK_EMAIL_CHANGED] = $t('changed email')
            data[TASK_LOG_TYPE.TASK_EMAIL_DELETED] = $t('deleted email')
            data[TASK_LOG_TYPE.TASK_EMAIL_SEND_SUCCESS] = $t('sent email')
            data[TASK_LOG_TYPE.TASK_EMAIL_SEND_FAILED] = $t('failed to send')

            return props.item.type in data ? data[props.item.type] : props.item.type
        })

        return {
            current_account,
            isActive,
            subject,
            content,
            taskLogType,
        }
    }
}
</script>

<style scoped>

</style>